// extracted by mini-css-extract-plugin
export default {"slideContainer":"ad2eded1ee _126cb6578d _08ab6dd883","slideImage":"_18a47a265b"};